import React from "react";
import Contents from "../components/pages/viewResume/Contents";

const ViewResume = () => {
    return (
        <Contents />
    );
}
export default ViewResume;
